import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';

import { TeacherMeetingJoinMutationVariables } from '@school_ify/schoolify-repository/src/teacher/types';

import LiveClass from '../../domain/services/bbb/meeting/Index';

interface IClassDetails {
  response: object;
  loading: 'idle' | 'pending' | 'success' | 'failed';
  error: string;
}

interface IInitialState {
  loading: 'idle' | 'pending' | 'success' | 'failed';
  response: object;
  error: string;
  classDetails: IClassDetails;
}

export const teacherJoin = createAsyncThunk(
  'teacher-join-live-class',
  async (variables: TeacherMeetingJoinMutationVariables) => {
    const teacherJoinedMeeting = await new LiveClass().teacherJoinMeeting(variables);
    return teacherJoinedMeeting;
  }
);

export const getClassDetails = createAsyncThunk('get-class-detials', async function (id: string) {
  const classDetails = await new LiveClass().getClassDetails({
    id,
  });
  return classDetails;
});

const initialState = {
  loading: 'idle',
  response: {},
  error: '',
  classDetails: {
    loading: 'idle',
    response: {},
    error: '',
  } as IClassDetails,
} as IInitialState;

const JoinLiveClassSlices = createSlice({
  name: 'joinLiveClassSlice',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(teacherJoin.pending, state => {
      state.loading = 'pending';
    });
    builder.addCase(teacherJoin.fulfilled, (state, action) => {
      state.loading = 'success';
      state.response = action.payload;
    });
    builder.addCase(teacherJoin.rejected, (state, action) => {
      state.loading = 'failed';
      state.error = action.error.message;
    });
    builder.addCase(getClassDetails.pending, state => {
      state.classDetails.loading = 'pending';
    });
    builder.addCase(getClassDetails.fulfilled, (state, action) => {
      state.classDetails.loading = 'success';
      state.classDetails.response = action.payload;
    });
    builder.addCase(getClassDetails.rejected, (state, action) => {
      state.classDetails.loading = 'failed';
      state.classDetails.error = action.error.message;
    });
  },
});

const exportState = state => state.joinLiveClassSlice;

export const joinLiveClassState = createSelector(exportState, obj => {
  return {
    loading: obj.loading,
    response: obj.response,
    classDetails: obj.classDetails,
  };
});

export default JoinLiveClassSlices.reducer;
